'use strict';
const flattenIdeasImpl = require('@mindmup/mapjs-core/src/content/flatten-ideas');
module.exports = function AssetLocaliser(localisers, optional) {
	if (!localisers || !localisers.length) {
		throw 'invalid-args';
	}
	const resourceManager = optional && optional.resourceManager,
		flattenIdeas = (optional && optional.flattenIdeas) || flattenIdeasImpl,
		ensureResources = function () {
			return Promise.resolve()
			.then(() => resourceManager && resourceManager.resignUrls());
		},
		localise = async function (content, localiserOptions) {
			const localiseIdea = (idea) => {
				return Promise.all(localisers.map(localiser => localiser(idea, localiserOptions)));
			};

			await ensureResources();
			if (optional?.localiseBackgroundImage) {
				await optional.localiseBackgroundImage(content, localiserOptions);
			}
			await Promise.all(flattenIdeas(content).map(localiseIdea));
			return content;
		};
	Object.freeze(Object.assign(this, {localise}));
};
